// Context
import {
  ACTIONS,
  useModalHistory,
} from "../../../context/ModalHistoryProvider";

// Components
import { ListPriceDealsButton } from "../../Controls/ListPriceDealsButton";
import { SchemeDealsButton } from "../../Controls/SchemeDealsButton";
import QueueStyle from "../../Styled/Queue.style";
import StackStyle from "../../Styled/Stack.style";
import Modal from "../../Modal/Modal";
import { CONDITIONS, DEAL_TYPES, NEW_CARS_ALLOWED_USERS, SCOPES, USED_CARS_ALLOWED_USERS, USER_KEY } from "../../../utils/constants/SYSTEM";
import { CreateUsedDealButton } from "../../Controls/CreateUsedDealButton";
import CreateEditUsedDealModal from "../CreateDeal/CreateEditUsedDealModal";
import CreateEditNewSchemeDealModal from "../CreateDeal/CreateEditNewSchemeDealModal";
import CreateEditNewListPriceDealModal from "../CreateDeal/CreateEditNewListPriceDealModal";
import { get } from "../../../utils/helpers/storage";

export default function IndividualDealCreateModal() {
  const [, dispatchModalHistory] = useModalHistory();

  const user = get(USER_KEY);
  const isNewCarsAllowedUser = NEW_CARS_ALLOWED_USERS.includes(user?.emailAddress?.toLowerCase());
  const isUsedCarsAllowedUser = USED_CARS_ALLOWED_USERS.includes(user?.emailAddress?.toLowerCase());

  const pushEnd = (modal) =>
    dispatchModalHistory({ type: ACTIONS.PUSH_END, payload: { value: modal } });

  const { NEW, USED } = CONDITIONS;
  const { INSTALMENT_PRICE, LIST_PRICE } = DEAL_TYPES;

  return (
    <Modal title="Choose a deal type to create">
      <StackStyle>
        <QueueStyle>
          <SchemeDealsButton
            onClick={() =>
              pushEnd(
                <CreateEditNewSchemeDealModal
                  dealCondition={NEW}
                  dealType={INSTALMENT_PRICE}
                  scope={SCOPES.CREATE}
                />
              )
            }
            disabled={!isNewCarsAllowedUser}
          />
              
          <ListPriceDealsButton
            onClick={() =>
              pushEnd(
                <CreateEditNewListPriceDealModal
                  dealCondition={NEW}
                  dealType={LIST_PRICE}
                  scope={SCOPES.CREATE}
                />
              )
            }
            disabled={!isNewCarsAllowedUser}
          />
        </QueueStyle>

        <br />
        <CreateUsedDealButton
          onClick={() =>
            pushEnd(
              <CreateEditUsedDealModal
                scope={SCOPES.CREATE}
                dealCondition={USED}
              />
            )
          }
          disabled={!isUsedCarsAllowedUser}
        />
      </StackStyle>
    </Modal>
  );
}
